import React from "react"
import PropTypes from "prop-types"
import memoize from "memoize-one"

import LottieExt from "react-lottie"

class Lottie extends React.PureComponent {
    getOptions = memoize((loop, autoplay, animationData) => ({
        loop,
        autoplay,
        animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    }))

    getLottieStyle = memoize((width, height) => ({
        margin: "0 auto",
        width,
        height,
    }))

    render() {
        const {
            className,
            loop,
            autoplay,
            animationData,
            isStopped,
            width,
            height,
            ...rest
        } = this.props

        const options = this.getOptions(loop, autoplay, animationData)
        const styles = this.getLottieStyle(width, height)

        return (
            <div style={styles} className={className}>
                <LottieExt
                    options={options}
                    width={width}
                    height={height}
                    isStopped={isStopped}
                    {...rest}
                />
            </div>
        )
    }
}

Lottie.propTypes = {
    className: PropTypes.string,
    loop: PropTypes.bool,
    autoplay: PropTypes.bool,
    animationData: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    isStopped: PropTypes.bool,
}

Lottie.defaultProps = {
    className: null,
    loop: false,
    autoplay: false,
    animationData: null,
    width: 100,
    height: 100,
    isStopped: false,
}

export default Lottie
